<template>
    <div>

        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <fieldset>
                    <div class="space-y-6 mt-6">

                        <div class="flex flex-col gap-4 sm:gap-6">
                            <div>
                                <label class="block text-sm font-medium text-gray-700"> Owner Address </label>
                                <input type="text" v-model="data.owner_address" name="Owner_Address" required placeholder="Enter mailing address city state" value="" class="mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"/>
                                <div class="text-red-600 text-sm px-1 py-1" v-if="errors.owner_address">
                                    <i class="fa fa-exclamation-triangle"></i> {{ errors.owner_address }}
                                </div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-gray-700">Mailing address state</label>
                                <input type="text" v-model="data.owner_cityState" name="Owner_CityState" required placeholder="Enter mailing address city state" value="" class="mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"/>
                                <div class="text-red-600 text-sm px-1 py-1" v-if="errors.owner_cityState">
                                    <i class="fa fa-exclamation-triangle"></i> {{ errors.owner_cityState }}
                                </div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-gray-700">Mailing address zip</label>
                                <input type="text" v-model="data.owner_zip" name="Owner_Zip" required placeholder="Enter mailing zip" value="" class="mt-1 p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md placeholder-gray-400"/>
                                <div class="text-red-600 text-sm px-1 py-1" v-if="errors.owner_zip">
                                    <i class="fa fa-exclamation-triangle"></i> {{ errors.owner_zip }}
                                </div>
                            </div>
                        </div>


                        <div class="mt-4 sm:mt-6 text-center border-t pt-4 sm:pt-6">
                            <a v-if="isModal" href="javascript::void(0)" @click="closeModal()" class="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-gray-400 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                                Close
                            </a>
                            <a v-else href="javascript::void(0)" @click="backToAoAPage()" class="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-gray-400 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                                Back
                            </a>
                            <button @click="submitHandler()" class="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Update</button>
                            <i v-if="isProcessing" class="fa fa-spinner fa-spin p-1"></i>
                        </div>
                    </div>
                </fieldset>
            </div>
    </div>
</template>

<script>
import ProtestRequestApi from "@/services/api/ProtestRequest.js";
import {apiUrl} from "../../../config/base.js";
export default {
    props:['protest-request','user-property','is-modal'],
    data() {
        return {
            data:{
                owner_address: this.userProperty.Owner_Address,
                owner_cityState: this.userProperty.Owner_CityState,
                owner_zip: this.userProperty.Owner_Zip,
                is_modal: this.isModal,
            },
            errors:{},
            isProcessing:false,
        }
    },
    created(){
        console.log(this.userProperty)

    },
    methods:{
        submitHandler(){
            console.log("Submit Handler Call");
            if(this.validate()){
                return false;
            }
            window.blockUI();
            this.isProcessing = true;
            ProtestRequestApi.changeMailingAddress(this.userProperty.uid,this.data, true).then((response)=>{
                if(response.data.error == false){
                    window.unblockUI();
                    this.isProcessing = false;
                    window.flash('Change Address Successfully',"success");
                    window.closeModal();
                }
            }).catch((error)=>{
                window.flash("Error: "+ error, "error");
            });
        },

        validate(){
            this.errors = {};
            let error = false;

            if(this.data.owner_address ==''){
                this.errors.owner_address = 'Please fill the owner address';
                error = true;
            }
            if(this.data.owner_cityState == ''){
                this.errors.owner_cityState = 'Please fill the city state';
                error= true;
            }
            if(this.data.owner_zip == ''){
                this.errors.owner_zip = 'Please fill the owner zip';
                error = true;
            }
            return error;
        },

        closeModal(){
            window.closeModal();
        },

        backToAoAPage(){
            window.location.href = apiUrl+ '/admin/aoa-review-system';
        }

    }
}
</script>
